import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import Icon from 'flarum/common/components/Icon';
import extractText from 'flarum/common/utils/extractText';
import MemberRow from './components/MemberRow';
import { STAFF_GROUP_IDS } from './utils/staffGroups';
import { memberListTitle } from './utils/memberListView';

/**
 * The member list - fof/user-directory's /users page - shown as a list,
 * like phpBB's member list, instead of that extension's profile cards: see
 * MemberRow. Its search, group filter, sorting and "Charger plus" stay.
 *
 * Every hook targets modules of fof/user-directory's page chunk, only
 * loaded on the way to /users - string paths apply them then.
 */
export default function addMemberList() {
  // Its title, in fof/user-directory's gray hero, with the header's
  // "Membres" menu icon (addMembersMenu.tsx) rather than an address book.
  override('ext:fof/user-directory/forum/components/UserDirectoryHero', 'heroIcon', () => 'fas fa-users');

  // "Membres connectés" or "L'équipe" when the header's menu opened one of
  // those - in the hero and the browser's tab (see memberListView).
  extend('ext:fof/user-directory/forum/components/UserDirectoryHero', 'contentItems', function (items) {
    const title = memberListTitle();
    if (title && items.has('user-directory-title')) {
      items.setContent('user-directory-title', m("h1", {
        className: "Hero-title"
      }, m(Icon, {
        name: this.heroIcon()
      }), " ", title));
    }
  });
  extend('ext:fof/user-directory/forum/components/UserDirectoryPage', 'setTitle', function () {
    const title = memberListTitle();
    if (title) app.setTitle(extractText(title));
  });

  // No sidebar: the IndexSidebar fof/user-directory gives the page would
  // be empty here (champis-forum keeps its nav and widgets to the
  // discussion lists) - PageStructure, which this view returns, renders
  // without one. Its toolbar is the blue bar over the list (champis-theme).
  extend('ext:fof/user-directory/forum/components/UserDirectoryPage', 'view', function (vdom) {
    vdom.attrs.sidebar = undefined;
  });

  // "Filtrer par groupe": only the team's groups (Admins, Mods) - not
  // the sociétés' or the species editors' ones. fof/user-directory keys
  // each group's choice by its plural name; its suspended-members choice,
  // a moderator's, isn't a group and stays.
  extend('ext:fof/user-directory/forum/components/UserDirectoryPage', 'groupItems', function (items) {
    app.store.all('groups').filter(group => !STAFF_GROUP_IDS.includes(group.id())).forEach(group => items.remove(group.namePlural()));
  });
  override('ext:fof/user-directory/forum/components/UserDirectoryListItem', 'view', function () {
    return m(MemberRow, {
      user: this.attrs.user
    });
  });

  // phpBB's sort by post count (aliases registered in extend.php), right
  // after the name sorts. Spreading the original map last keeps every
  // other key, in its own order.
  override('ext:fof/user-directory/common/utils/SortMap', 'sortMap', function (original) {
    const map = original();
    const byName = Object.fromEntries(Object.entries(map).filter(_ref => {
      let [key] = _ref;
      return key.startsWith('username_');
    }));
    return {
      ...byName,
      most_posts: '-commentCount',
      least_posts: 'commentCount',
      ...map
    };
  });
}